import { ChangeEventHandler, FC, useState } from 'react';

import { omit } from 'remeda';
import useSWRMutation from 'swr/mutation';

import Checkbox from '@mui/material/Checkbox';

import { distributionLinksService } from 'v2/api/distributionLinksService';
import { DistributionLinkModel } from 'v2/types/DistributionLinkModel';
import { handleHttpError } from 'v2/utils';

interface DistributionLinkActiveColumnProps {
  distributionLink: DistributionLinkModel;
}

export const DistributionLinkActiveColumn: FC<DistributionLinkActiveColumnProps> = ({ distributionLink }) => {
  const [isChecked, setChecked] = useState(distributionLink.isActive);

  const { trigger } = useSWRMutation(
    ['updateDistributionLink', distributionLink.id],
    distributionLinksService.updateDistributionLink,
    {
      onSuccess: (distributionLink) => {
        setChecked(distributionLink.isActive);
      },
      onError: handleHttpError,
    }
  );

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    trigger({ ...omit(distributionLink, ['id', 'url']), isActive: e.target.checked });
  };

  return <Checkbox color="success" checked={isChecked} onChange={handleChange} />;
};
